// #region Imports

import Vue from 'vue';
// io.base Page-Components
import '@/modules/base-pages';

// #endregion

// #region Component Registration

Vue.component('IoBaseAppCards', () => import(/* webpackChunkName: "base-components" */ '@/base/apps/AppCards.vue'));
Vue.component('IoBaseMonitoringDashboard', () => import(/* webpackChunkName: "base-monitoring" */ '@/base/monitoring/MonitoringDashboard.vue'));
Vue.component('TableCard', () => import(/* webpackChunkName: "base-components" */ '@/base/TableCard.vue'));

// #endregion
